import { Spin } from "antd";
import React from "react";

export const Home = () => {
	return (
		<div className="images-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
			<Spin size="large" />
		</div>
	);
};
